import React from "react";
import DoctorSideBar from "./Doctor-Sidebar";
import Youroheader from "../Youro-header";
import HelpSupportView from "../Patient UI/HelpSupportView";
import "../../styles/Doctor-ui/Doctor-appointment/Doctor-Appointment-page.css";

/**
 * Help & Support for providers.
 *
 * Patients see HelpSupportView as a view inside their profile switcher, so it
 * had no route and the provider menu fell through to /doctor-profile. The
 * content — contact details, support hours, the message form — is not
 * patient-specific, so it is reused here inside the provider chrome rather than
 * duplicated.
 */
const DoctorHelpSupport = () => (
  <div>
    <div className="d-app">
      <div className="sidebar">
        <DoctorSideBar data={"doctor-help"} />
      </div>
      <div className="d-calender">
        <Youroheader />
        <HelpSupportView />
      </div>
    </div>
  </div>
);

export default DoctorHelpSupport;
